import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type AppEnv } from '../components/app.hooks';
import { type SliceState, type UpdateConfigApiKeysPayload, type UpdateDomainsPayload } from './configSlice.types';

export const initialState: SliceState = {
  services: {
    ILINK: { url: '/ilink/v1' },
    ILINK_V2: { url: '/ilink/v2' },
    ILINK_V3: { url: '/ilink/v3' },
    ILINK_V4: { url: '/ilink/v4' },
    SHARE: { url: '/share_api' },
    DDFS: { url: '/dictionaries', api_key: '' },
    SPID: { url: '/spid/v4' },
    MASTERDATA: { url: '/masterdata/v2' },
    REPAIR_CATALOG: { url: '/repair-catalog-helper' },
  },
  domainApi: '',
  appEnv: 'development',
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    updateDomains: (state, action: PayloadAction<UpdateDomainsPayload>) => {
      const { domainApi } = action.payload;

      state.domainApi = domainApi;
      Object.values(state.services).forEach(service => {
        service.url = domainApi + service.url;
      });
    },
    updateConfigApiKeys: (state, action: PayloadAction<UpdateConfigApiKeysPayload>) => {
      state.services.DDFS.api_key = action.payload.ddfsKey;
    },
    updateAppEnv: (state, action: PayloadAction<AppEnv>) => {
      state.appEnv = action.payload;
    },
  },
});

export const { updateConfigApiKeys, updateDomains, updateAppEnv } = configSlice.actions;

export default configSlice.reducer;
